import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { UserActionBaseComponent } from '../userAction-base.component';
import { Customer } from '../../../../Model/User/Customer';
import { UpdateTemplate } from '../../../../Model/Catalog/UpdateTemplate';
import { TranslateService } from '@ngx-translate/core';
import { duplicateItem } from '../../../../Model/Dto/DublicateItem';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { Router } from '@angular/router';
import { SystemService } from 'app/Services/system.service';

@Component({
  selector: 'userAction-spreadCatalog',
  templateUrl: 'userAction-spreadCatalog.component.html',
  providers: [
    { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionSpreadCatalogComponent) }
  ]})
export class UserActionSpreadCatalogComponent extends UserActionBaseComponent {
  _customers: Customer[];

  _sourceCatalog: string = '';
  selectedCustomers: string[];
  updateTemplates: UpdateTemplate[];

  txtSelectCatalog: string;

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    public router: Router,
    public systemService: SystemService
  ) {
    super(loginService, macroService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loginService.customerService
      .getAllCustomerByUser(this.loginService.currentUser.id)
      .subscribe((customers: Customer[]) => {
        this.customers = new Array<Customer>();
        customers.forEach((customer: Customer) => {
          if (customer.id != this.loginService.currentCustomer.id) {
            this.customers.push(customer);
          }
        });
      });
  }

  editTemplatesClick() {
    this.router.navigate(['updateTemplates']);
  }

  get customers(): Customer[] {
    return this._customers;
  }

  set customers(value: Customer[]) {
    this._customers = value;
  }

  get sourceCatalog(): string {
    return this._sourceCatalog;
  }

  set sourceCatalog(sourceCatalog: string) {
    this._sourceCatalog = sourceCatalog;
  }

  public async canStartMacro() : Promise<boolean>{
    if (this.selectedCustomers.length == 0) {
      this.systemService.notifyInfo(this.txtSelectCatalog);
      return false;
    }

    return true;
  }

  parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.selectedCustomers = parsed.selectedCustomers;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }

  createParameterStringAsJsonString(): string {
    let duplicateCatalog = new duplicateItem();
    duplicateCatalog.sourceCustomerId = this.loginService.currentUser.customerId;
    duplicateCatalog.sourceItemId = this.catalogService.selectedCatalogId;
    let parameterJsonString = JSON.stringify({selectedCustomers : this.selectedCustomers, duplicateItem: duplicateCatalog});
    return parameterJsonString;
  }
}
